import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/contexts/AuthContext';
import { AppProvider } from '@/contexts/AppContext';
import { I18nProvider } from '@/contexts/I18nContext';
import ErrorBoundary from '@/components/ErrorBoundary';
import AccountExpiredModal from '@/components/AccountExpiredModal';
import AnnouncementWrapper from '@/components/AnnouncementWrapper';
import AppRoutes from './routes';
import './styles/globals.css';
import VersionStamp from '@/components/VersionStamp';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <AppProviderWrapper>
              <I18nProviderWrapper>
                <AppRoutes />
                <AccountExpiredModal />
                <VersionStamp />
              </I18nProviderWrapper>
            </AppProviderWrapper>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

// Wrapper components to handle provider dependencies
const AppProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <AppProvider>{children}</AppProvider>;
};

const I18nProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <I18nProvider>
      {children}
      <AnnouncementWrapper />
    </I18nProvider>
  );
};

export default App;
